import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ArApWriteOffsDto } from "../../../../dtos/documents/ArApWriteOffs/ArApWriteOffsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFPlainText } from "../../../Shared/NewForms/NFPlainText";
// import { PostingOfGoodsModel } from "../../../../models/Documents/PostingOfGoodsModel";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { ArApWriteOffsModel } from "../../../../models/Documents/ArApWriteOffsModel/ArapWriteOffsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import ArApWriteOffsDetailSkeleton from "./ArApWriteOffsDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { ArApWriteOffsDetailFooter } from "./ArApWriteOffsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: ArApWriteOffsDto | null;
  modelUpdatedEvent: (newModel: ArApWriteOffsDto) => void;
}

// const resolver: Resolver<OpenBalanceOfGoodsDto> = async (values) => {
//     return {
//         values: values.documentNumber ? values : {},
//         errors: !values.documentNumber
//             ? {
//                 documentNumber: {
//                     type: 'required',
//                     message: 'This is required.',
//                 },
//             }
//             : {},
//     };
// };

export const ArApWriteOffsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ArApWriteOffsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("ArAp Write Off");
  // const watchProducts = watch("postingOfGoodGoods");

  useEffect(() => {
    console.log(model);
    // register("postingOfGoodGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("divisionId", model.divisionId);
      setValue("writeOffItem", model.writeOffItem);
      setValue("paymentType", model.paymentType);
      setValue("companyId", model.companyId);
      setValue("currencyId", model.currencyId);
    }
  }, [model]);

  // useEffect(() => {
  //     console.log(watchProducts);
  // }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: ArApWriteOffsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: ArApWriteOffsDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ArApWriteOffsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ArApWriteOffsDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.ArApWriteOffs.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} fieldName={"documentNumber"} disabled />
            </Col>
            <Col sm={3}>
              <NFDateInput title={"Document Date"} fieldName={"createdDate"} required={true} />
            </Col>
            <Col sm={3}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Write Off"} fieldName={"writeOffItem"} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={"Payment Type"} fieldName={"paymentType"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} />
            </Col>
          </Row>

          <Row>
            {/* <Col sm={6}>
                            <NFLookupCompany fieldName={"partnerId"} title={"Partner"} />
                        </Col> */}
            <Col sm={6}>
              <NFLookupCurrency fieldName={"currencyId"} title={"Currency"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"ArApOffsets"}>
            <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={300} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} />
            <NFIntInput fieldName={"amountLocalAccountsPa"} title={"Amount Local Accounts Payable"} width={100} />
            <NFPlainText fieldName={"productVendorCode"} title={"Product Vendor Code"} width={150} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <ArApWriteOffsDetailFooter />
    </FormProvider>
  );
};
